import Format from "utils/format/Format";

const Data = () => [
  {
    title: "Tên cửa hàng",
    dataIndex: "name",
    key: "name",
    copyable: true,
    render: (_: any, record: any, index: number) => {
      return (
        <div style={{ textAlign: "center" }} className="truncate-text">
          {record.name || ""}
        </div>
      );
    },
  },
  {
    title: "STB Addkit",
    dataIndex: "stb",
    key: "stb",
    render: (_: any, record: any, index: number) => {
      return (
        <div
          style={{ textAlign: "center", fontWeight: 700 }}
          className="truncate-text"
        >
          {Format.vndPrice(record?.stb)}
        </div>
      );
    },
  },
  {
    title: "STB ĐKTTTB",
    dataIndex: "dktttb",
    key: "dktttb",
    render: (_: any, record: any, index: number) => {
      return (
        <div
          style={{ textAlign: "center", fontWeight: 700 }}
          className="truncate-text"
        >
          {Format.vndPrice(record?.dktttb)}
        </div>
      );
    },
  },
  {
    title: "Hoa hồng",
    dataIndex: "rose",
    key: "rose",
    render: (_: any, record: any, index: number) => {
      return (
        <div style={{ textAlign: "center" }} className="truncate-text">
          {Format.DPrice(record?.rose)}
        </div>
      );
    },
  },
];

export default Data;
